import { render, staticRenderFns } from "./PlainControl.vue?vue&type=template&id=817df4aa"
import script from "./PlainControl.vue?vue&type=script&lang=ts"
export * from "./PlainControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports